import {Form, Formik} from 'formik';
import {ChangeEvent} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import DotsLoading from '../../../../../components/dotsLoading';
import FormikLikeInput from '../../../../../components/formikFileds/likeInput';
import {RootState} from '../../../../../store/redux';
import {addRegisterStoreFormData} from '../../../../../store/redux/registerStore';
import {OwnerDetailSchema} from '../../contants';
import NationalCardUploader from './NationalCardUploader';

const OwnerDetail = ({
  mode,
  touched,
  setTouched,
  setCurrentStep,
  profileData,
}: IOwnerDetailProps) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const state = useSelector((state: RootState) => state.registerStore);

  const storeType = state?.storeType?.trim() || params?.storeType;

  const isLendTech = storeType
    ? ['dokan', 'khish', 'nasagh'].includes(storeType)
    : false;

  const onSuccess = () => {
    state.selectedInput?.id === 2 ? setCurrentStep(4) : setCurrentStep(3);
  };

  const disableContinueButton =
    !state.national_card?.file && !state.national_card?.national_card;

  const initialValue = () => {
    return {
      phone_number: profileData?.phone?.startsWith('98')
        ? '0' + profileData?.phone.substring(2)
        : profileData?.phone,
      name: profileData?.name,
      supplier_profile_guid: state?.supplier_profile_guid,
    };
  };
  return false ? (
    <div className="flex items-center justify-center h-full">
      <DotsLoading />
    </div>
  ) : (
    <Formik
      initialValues={initialValue()}
      validationSchema={OwnerDetailSchema}
      enableReinitialize
      onSubmit={values => {
        if (state.national_card?.file || state.national_card?.national_card) {
          dispatch(
            addRegisterStoreFormData({
              ...state,
              name: values?.name,
              supplier_profile_guid: values?.supplier_profile_guid,
            }),
          );

          onSuccess();
        }
      }}
    >
      {({setFieldValue, handleSubmit, values, errors}) => {
        return (
          <div className="flex flex-col justify-between h-full mt-12">
            <Form className="flex flex-col h-full gap-4 overflow-y-auto">
              {isLendTech && (
                <section className="flex flex-col ">
                  <p className="mb-3 font-medium text-neutral-600 text-md ">
                    تصویر کارت ملی مالک فروشگاه
                    <span className="color-red-3">*</span>
                  </p>
                  <NationalCardUploader
                    file={state.national_card?.file}
                    imageUrl={state.national_card?.national_card}
                    onChange={file => {
                      dispatch(
                        addRegisterStoreFormData({
                          ...state,
                          national_card: {
                            file,
                            national_card: '',
                          },
                        }),
                      );
                    }}
                  />
                </section>
              )}

              <section>
                {!isLendTech &&
                  (state.selectedInput?.id === 2 ? (
                    <p className="mb-3 font-medium color-gray-1 text-md ">
                      مشخصات مسئول آزمایشگاه
                      <span className="color-red-3">*</span>
                    </p>
                  ) : (
                    <p className="mb-3 font-medium color-gray-1 text-md ">
                      مشخصات مالک فروشگاه <span className="color-red-3">*</span>
                    </p>
                  ))}
                <FormikLikeInput
                  name="name"
                  touched={touched}
                  label="نام و  نام خانوادگی"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('name', e.target.value);
                    // setOwnerStoreName(e.target.value);
                  }}
                  value={values.name}
                />
              </section>

              <section>
                <FormikLikeInput
                  name="phone_number"
                  label="شماره تلفن همراه"
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('phone_number', e.target.value);
                  }}
                />
              </section>
              {!isLendTech && (
                <section className="flex flex-col ">
                  <span className="mb-3 text-md">
                    {state.selectedInput?.id === 2
                      ? 'تصویر کارت ملی مسئول آزمایشگاه را بارگذاری کنید.'
                      : 'تصویر کارت ملی مالک فروشگاه را بارگذاری کنید.'}
                    <span className="color-red-3">*</span>
                  </span>

                  {state.national_card?.file ||
                  state.national_card?.national_card ? (
                    <div className="flex flex-col w-full">
                      <div className="w-full min-h-[128px] max-h-[128px] rounded-[8px] border-dashed border-[2px] border-gray-700 relative">
                        <div
                          className="absolute rounded-[8px] bg-white flex items-center justify-center p-1 text-white left-2 top-2"
                          onClick={() => {
                            dispatch(
                              addRegisterStoreFormData({
                                ...state,
                                national_card: {
                                  file: null,
                                  national_card: '',
                                },
                              }),
                            );
                          }}
                        >
                          <SpanIcon className="text-xl text-red-600 icon-nameDelete" />
                        </div>
                        <img
                          className="object-cover w-full h-full"
                          src={
                            state?.national_card.national_card
                              ? state?.national_card.national_card
                              : (state?.national_card.file &&
                                  URL.createObjectURL(
                                    state?.national_card.file,
                                  )) ||
                                ''
                          }
                          alt="upload_images"
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <label
                        htmlFor="nationalCard"
                        className="flex gap-1 items-center justify-center text-md h-32 w-full rounded border-[2px] border-dashed text-gray-700"
                      >
                        <SpanIcon className="icon-nameImage-plus text-l" />
                      </label>
                      <input
                        onChange={event => {
                          dispatch(
                            addRegisterStoreFormData({
                              ...state,
                              national_card: {
                                file:
                                  (event?.target?.files &&
                                    event?.target?.files.length > 0 &&
                                    event.target.files[0]) ||
                                  null,
                                national_card: '',
                              },
                            }),
                          );
                        }}
                        className="hidden"
                        type="file"
                        id="nationalCard"
                        name="nationalCard"
                        accept="image/png, image/jpeg"
                      />
                    </div>
                  )}
                  {touched &&
                    !state.national_card?.file &&
                    !state.national_card?.national_card && (
                      <span className="mt-2 text-xs text-red-600">
                        انتخاب تصویر الزامی است
                      </span>
                    )}
                </section>
              )}
            </Form>
            <section className="flex flex-1 h-12 gap-2">
              {mode !== 'edit' && (
                <button
                  className="flex flex-2 bg-white text-green-main justify-center items-center rounded border-[1px] border-green-main px-3"
                  onClick={() => {
                    navigate('/register-store-lab');
                  }}
                >
                  مرحله قبل
                </button>
              )}
              <button
                className={`flex items-center justify-center flex-1 h-12 text-white rounded bg-green-main *:disabled:opacity-50 disabled:bg-gray-400 disabled:text-white disabled:cursor-not-allowed`}
                onClick={() => {
                  setTouched(true);
                  handleSubmit();
                }}
                disabled={disableContinueButton}
                type="submit"
              >
                ادامه
              </button>
            </section>
          </div>
        );
      }}
    </Formik>
  );
};

export default OwnerDetail;
